<template>
    <div class="alert-position">
    <b-alert :show="show" dismissible variant="warning">
        <h4 class="alert-heading">Avviso compatibilità browser!</h4>
        <p class="mb-0">
        Il browser che stai utilizzando non è adatto alla visualizzazione di questa pagina.
        </p>
        <hr>
        <p class="mb-0">
        Ti consigliamo l'utilizzo di un browser moderno come Google Chrome, Mozilla Firefox, Opera, Microsoft Edge.
        </p>
    </b-alert>
    </div>
</template>

<style scoped>
.alert-position {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}

.alert {
    border-radius: 0;
}
</style>

<script>
export default {
    name: 'Navbar',
    data: function() {
    return {
        show: false,
        }
    },
	mounted() {
    this.checkBrowser()
  },
  methods: {
    checkBrowser() {
        var ua = window.navigator.userAgent;
        var isIE = /MSIE|Trident/.test(ua); // solo internet explorer
        if ( isIE ) {
            this.show = true
        }
    },
  }
}
</script>